import { PromotionCard, PromotionCardProps } from '@/screens/Sales/page/ui/PromotionCard/PromotionCard'

import { Col, Row } from '@/shared/ui/Grid'

import { SalesItemTypes } from '../../../../../../store/types/sales'

export type TPromotionsList = {
	items: PromotionCardProps[] | SalesItemTypes[]
}

export const PromotionsList = ({ items }: TPromotionsList): JSX.Element => {
	const salesList = items?.filter(({ HIDE_ON_LIST }) => !HIDE_ON_LIST)

	return (
		<section>
			<Row gutter={[0, 20]} justify="start">
				{salesList?.map(item => (
					<Col key={item.CODE} lg={8} sm={12} xs={24}>
						<PromotionCard {...item} />
					</Col>
				))}
			</Row>
		</section>
	)
}
